export const isValidPhone = (phoneNumber) => {
  const phoneNumberRegex = /^\+.{3,}$/
  return phoneNumberRegex.test(phoneNumber)
}
